import Vue from "vue"

Vue.$bus = Vue.prototype.$bus = new Vue()